import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { DateTime } from 'luxon'

type FutureClockInProps = { startTime: Date }

/**
 * "Clocked in as of <date>" — shown when the operator has clocked into a shift
 * that hasn't started yet. Pure presentational; the caller decides when it's a
 * future shift (see `useIsFutureTime`). Mirrors the v1 crew app.
 */
export const FutureClockIn = ({ startTime }: FutureClockInProps) => {
  const { _ } = useLingui()
  const formatted = DateTime.fromJSDate(startTime)
    .toLocal()
    .toFormat('LL/dd hh:mma')

  return (
    <span className='timeclock-future-clockin'>
      <small className='timeclock-future-clockin__label'>
        {_(msg`Clocked in as of`)}
      </small>
      <span className='timeclock-future-clockin__time'>{formatted}</span>
    </span>
  )
}
